document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  const header = document.getElementById('header');
  if (header) window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 50));

  document.querySelectorAll('[data-faq-question]').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const group = btn.closest('.faq-grid');
      const isOpen = item.classList.contains('open');
      if (group) group.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  document.querySelectorAll('.filter-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-tab').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  document.querySelectorAll('.mobile-menu-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const nav = document.querySelector('.nav');
      if (nav) nav.classList.toggle('nav-open');
    });
  });

  document.querySelectorAll('.nav-item > .nav-link').forEach(link => {
    link.addEventListener('click', (e) => {
      if (window.innerWidth <= 1024 && link.nextElementSibling && link.nextElementSibling.classList.contains('dropdown')) {
        e.preventDefault();
        link.parentElement.classList.toggle('open');
      }
    });
  });

  document.querySelectorAll('.product-accordion > button').forEach(btn => {
    btn.addEventListener('click', () => btn.parentElement.classList.toggle('open'));
  });

  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-large');
      const main = document.querySelector('.product-featured-media img');
      if (src && main) main.src = src;
    });
  });

  document.querySelectorAll('.ajax-product-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }});
        if (!response.ok) throw new Error('Cart error');
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
        if (btn) btn.innerHTML = '✓ Added';
        setTimeout(() => { if (btn) { btn.innerHTML = original; btn.disabled = false; }}, 1200);
      } catch(err) {
        form.submit();
      }
    });
  });

  document.querySelectorAll('.product-wishlist').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
      btn.textContent = btn.classList.contains('active') ? '♥' : '♡';
    });
  });
});
